module.exports = __webpack_public_path__ + "img/Ramon Marquez.ee24eb55.jpg";